import React from 'react';
import {NavLink as Link} from 'react-router-dom';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import './ModelList.scss';

export default (props) => {
  function yearSpan(startYear, endYear) {
    let yearSpan = null;
    if (startYear === endYear) {
      yearSpan = startYear;
    } else {
      if (!endYear) {
        endYear = '';
      }
      yearSpan = `${startYear} - ${endYear}`;
    }

    return yearSpan;
  }

  function printWarningIcon(files, articles) {
    if (files === 0 || articles === 0) {
      const icon = (
        <OverlayTrigger placement="top" overlay={tooltip('Generasjon mangler filer eller artikler')}>
          <span className="fa fa-exclamation-triangle text-warning" aria-hidden="true"></span>
        </OverlayTrigger>
      );

      return icon;
    }
    return;
  }

  function tooltip(text) {
    const tooltip = (
      <Tooltip>
        {text}
      </Tooltip>
    );

    return tooltip;
  }

  function listGenerations(model) {
    const generationItems = [];

    props.generations.forEach((generation) => {
      if (generation.model && (model.id === generation.model.id)) {
        generationItems.push(
          <li className="list-group-item generation-list-item">
            <PublishStatusDot entry={generation} />&nbsp;&nbsp;
            <Link to={`/mypage/${props.make.id}/generations/${model.id}/${generation.id}/`}>
              {yearSpan(generation.startYear, generation.endYear)}
            </Link>
            &nbsp;
            {printWarningIcon(generation.articles.length, generation.files.length)}
            <div className="pull-right">
              <OverlayTrigger placement="top" overlay={tooltip('Antall artikler for denne generasjonen')}>
                <span className="badge">{generation.articles.length}</span>
              </OverlayTrigger>
              &nbsp;
              <OverlayTrigger placement="top" overlay={tooltip('Antall filer for denne generasjonen')}>
                <span className="badge">{generation.files.length}</span>
              </OverlayTrigger>
            </div>
          </li>);
      }
    });

    if (generationItems.length > 0) {
      return (
        <ul className="list-group generation-entity-list">
          {generationItems}
        </ul>
      );
    }

    const noGenerationText =
    <label>Det finnes ingen generasjoner for denne modellen. Trykk <Link to={`/mypage/${props.make.id}/generations/${model.id}/new`}>her</Link> for å opprette en ny.</label>;

    return noGenerationText;
  }

  return (
    <div className="row">
      {props.models.map((model) => {
        let cls = 'thumbnail alert alert-warning model-entity';

        if (model.published) {
          if (model.updated) {
            cls = 'thumbnail alert alert-info model-entity';
          } else {
            cls = 'thumbnail alert alert-success model-entity';
          }
        } else if (model.archived) {
          cls = 'thumbnail alert alert-danger model-entity';
        }

        return (
          <div className="col-xs-6 col-lg-3 model-entity" key={model.id}>
            <div className={cls}>
              <Link to={`/mypage/${props.make.id}/generations/${model.id}`}>
                <h4><center>{model.name}</center></h4>
              </Link>
              {listGenerations(model)}
            </div>
          </div>
        );
      })}
    </div>
  );
};
